<bb-transactions-list-widget [showControls]="true"
  paginationType="load-more"
  pageSize="10"
  [showManageNotes]="false"
  initialSortOptions="creationTime DESC"
  [showPendingTransactionsOnTop]="true">

  <ng-template bbTransactionsListControlsCustomizable
    let-hostRef>
    <div class="card-header"
      [ngClass]="{'bb-block--lg': hostRef.isFilterOpen}">
      <div class="bb-stack bb-stack--wrap">
        <div
          class="bb-stack__item bb-stack__item--fill--md-up align-self-start bb-transaction-list-controls__filter-buttons">
          <div class="bb-stack">
            <div class="transaction-controls-container bb-stack__item bb-stack__item--fill--md-up">

              <!-- Search button -->
              <div class="bb-transaction-list-controls__search-box bb-stack__item">
                <div class="input-group">
                  <label class="sr-only"
                    bbDynamicId
                    #searchLabel
                    i18n="search transaction filter@@transactions.search.label">
                    Search transaction filter
                  </label>
                  <bb-search-box-ui [showSearch]="true"
                    [showClear]="true"
                    placeholder="Search"
                    [aria-labelledby]="searchLabel?.id"
                    searchLabel="search"
                    i18n-searchLabel="search label when button in focus@@transactions.searchLabel.search.box "
                    i18n-placeholder="search transactions placeholder@@transactions.ariaLabel.search.placeholder"
                    (submit)="hostRef.onSearch($event)"
                    (clear)="hostRef.onSearch('')">
                  </bb-search-box-ui>
                </div>
              </div>

              <button bbButton
                class="bn-transactions-filter-button"
                *ngIf="hostRef.activeFilters"
                [attr.aria-expanded]="!!hostRef.isFilterOpen"
                [color]="hostRef.isFilterApplied || hostRef.isFilterOpen ? 'primary' : 'secondary'"
                data-role="filter"
                (click)="hostRef.toggleFilter()">
                <bb-icon-ui *ngIf="!hostRef.activeFilters" name="filter"></bb-icon-ui>
                <bn-badge-counter-ui
                  *ngIf="hostRef.activeFilters"
                  class="ml-n3 px-1"
                  [count]="hostRef.activeFilters"
                  [border]="true"
                ></bn-badge-counter-ui>
                <span class="mb-0 bb-block--md bb-transaction-list-controls__long-button"
                  i18n="Filter toggle button@@transactions.filtersApplied.button">Filters applied
                </span>
              </button>

              <button bbButton
                class="bn-transactions-filter-button"
                *ngIf="!hostRef.activeFilters"
                [attr.aria-expanded]="!!hostRef.isFilterOpen"
                [color]="hostRef.isFilterApplied || hostRef.isFilterOpen ? 'primary' : 'secondary'"
                data-role="filter"
                (click)="hostRef.toggleFilter()">
                <bb-icon-ui name="filter"></bb-icon-ui>
                <ng-container i18n="Filter toggle button@@transactions.filter.button">Filter</ng-container>
              </button>
            </div>
            <!--            <ng-container [ngTemplateOutlet]='number % 2 == 0 ? even_tpl : odd_tpl' [ngTemplateOutletContext]="{number:number}"></ng-container>-->

            <ng-container bbTransactionsListControlsButtonsCustomizable
              [bbHostRef]="hostRef"></ng-container>
          </div>
        </div>
      </div>
    </div>
    <bb-transactions-filter (filter)="hostRef.onFilter($event)"
      (filterCount)="hostRef.onFilterCount($event)"
      (closeFilter)="hostRef.onClose()"
      [hidden]="!hostRef.isFilterOpen"
      [hideBillingStatus]="hostRef.hideBillingStatus"></bb-transactions-filter>
    <bn-transaction-item-details [isOpen]="isModalOpen"
      [hostRef]="hostRef"
      (close)="closeModalDetails()"
      [transaction]="currentTransaction"></bn-transaction-item-details>
  </ng-template>

  <ng-template bbTransactionsListControlsButtonsCustomizable
    let-hostRef>
    <!-- Print button -->
    <button bbButton
      class="bb-stack__item"
      color="secondary"
      [circle]="true"
      (click)="hostRef.onPrint()">
      <bb-icon-ui name="print"></bb-icon-ui>
      &#8203;
      <span class="sr-only"
        i18n="Print button@@transactions.print.button">Print</span>
    </button>
    <!-- Export button -->
    <bb-dropdown-menu-ui *ngIf="exportConfig?.length"
      container="body"
      icon="expand-more"
      btnColor="secondary"
      ariaLabel="available export types"
      btnCircle="true"
      icon="get-app"
      iconSize="md"
      i18n-ariaLabel="Menú desplegable de tipos de exportación disponibles actualmente@@transactions.list.exportList.ariaLabel">
      <ng-template bbDropdownMenuItem>
        <a *ngFor="let exportType of exportConfig"
          role="menuitem"
          class="dropdown-item"
          (click)="hostRef.onExport(exportType)"
          href="javaScript:void(0);"
          bbAccessibilityKeyboard>
          <span>{{ exportType.name }}</span>
        </a>
      </ng-template>
    </bb-dropdown-menu-ui>
  </ng-template>

  <ng-template bbTransactionsListFilterCustomizable
    let-hostRef>
    <bn-transactions-filter [hostRef]="hostRef"></bn-transactions-filter>
  </ng-template>

  <ng-template bbPendingTransactionsListCustomizable
    let-hostRef>
    <div class="bb-block bb-block--md">
      <strong role="heading"
        class="bb-block bb-block--md"
        aria-level="2"
        tabindex="0">
        <div class="bb-transactions-list-pending-header bb-block--md">
          <span class="bb-subheader"
            i18n="Pending transactions header@@transactions.list.pending.header">Pending</span>
          <span class="bb-transactions-list-pending-header__tooltip"></span>
        </div>
      </strong>
      <div class="bb-list">
        <div class="bb-list__item">
          <div class="bb-block--md"
            *ngFor="let transaction of hostRef.transactionsList?.items">
            <bn-transaction-list-item *ngIf="transaction?.billingStatus !== lastTransactionRecordIndicator"
              [categoryIcon]="getUrlIcon(transaction?.typeGroup)"
              (selectItem)="openModalDetails($event)"
              [showBalanceData]="false"
              [accountType]="accountType"
              [transaction]="transaction">
            </bn-transaction-list-item>
          </div>
        </div>
        <!-- forcing a line separator in bb-list-->
        <div class="bb-list__item"></div>
      </div>

    </div>
  </ng-template>

  <!--  TRANSACTION LIST-->
  <ng-template bbTransactionsListItemGroupCustomizable
    let-hostRef>
    <div role="heading"
      aria-level="2"
      class="bb-transaction-group__date bb-block--md bb-subheader"
      i18n="Date of the selected transaction@@transactions.list.transactionDate"
      tabindex="0">
      {hostRef.daysElapsed, plural, =0 {Today} =1 {Yesterday} other {{{ hostRef.transactionDate | date:'longDate' }}} }
    </div>
    <div>
      <div role="list">
        <div class="bb-block--md"
          *ngFor="let transaction of hostRef.transactions"
          role="listitem">
          <bn-transaction-list-item *ngIf="transaction?.billingStatus !== lastTransactionRecordIndicator"
            [categoryIcon]="getUrlIcon(transaction?.typeGroup)"
            (selectItem)="openModalDetails($event)"
            [showBalanceData]="showBalanceData"
            [accountType]="accountType"
            [transaction]="transaction">
          </bn-transaction-list-item>
        </div>
      </div>
    </div>
  </ng-template>
  <!--  END TRANSACTION LIST-->

  <ng-template bbTransactionsListPaginationCustomizable
    let-hostRef>
    <div class="bb-block bb-text-align-center">
      <div data-role="load-more"
        *ngIf="hostRef.isPaginationLoadMore">
        <bb-load-button-ui color="link"
          [isLoading]="hostRef.isLoadingMore"
          [totalCount]="hostRef.transactionsList.totalCount"
          (paramChange)="hostRef.onLoadMore($event)"
          i18n="Load more button, when there are still transactions to be loaded@@transactions.list.loadMore"
          *ngIf="!hasLoadedAll(hostRef.transactionsList.items, hostRef.transactionsList.totalCount)">Load more
        </bb-load-button-ui>
        <span i18n="Displayed message when all transactions had been loaded@@transactions.list.loadedAll"
          *ngIf="hasLoadedAll(hostRef.transactionsList.items, hostRef.transactionsList.totalCount)">All transactions
          have been loaded.</span>
      </div>
    </div>
  </ng-template>

  <ng-template bbTransactionsErrorStateCustomizable
    let-hostRef>
    <div class="card">
      <div class="card-body bb-text-align-center ">
        <div>

          <ng-container>
            <div class="bb-state-container banesco-empty-state empty-state-container">
              <div>
                <div class="mb-3 bb-beneficiary-selector-ui__not-found-title empty-state-title"
                  i18n="@@dashboard.empty.state.title">
                  Something went wrong
                </div>
                <div class="empty-state-one"
                  i18n="@@dashboard.empty.state-subtitle-one">
                  Unfortunately, the application is not available now.
                </div>

                <div class="empty-state-two"
                  i18n="@@dashboard.empty.state-subtitle-two">
                  Please try again later or contact us at:
                </div>

                <div class="bank-numbers text-left">
                  <ul>
                    <li>829-893-8200,</li>
                    <li i18n="@@dashboard.empty.number">Dominican Republic free of charges 1-809-200-1101 and,</li>
                    <li i18n="@@dashboard.empty.number.two">Whatsapp 829-647-8100.</li>
                  </ul>
                </div>
              </div>

              <div class="not-found-img"></div>

            </div>

          </ng-container>

          <button i18n="Retry button@transactions.state.error.retry-button"
            bbButton
            (click)="hostRef.retry()">Retry</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template bbTransactionsListEmptyStateCustomizable
    let-hostRef>
    <div class="bb-text-align-center card-body">
      <ng-container>
        <div class="bb-state-container banesco-empty-state">
          <div class="mb-3 bb-beneficiary-selector-ui__not-found-title empty-state-title"
            i18n="@@beneficiary-selector.not-found.title">
            No results found
          </div>
          <div class="mb-3"
            i18n="@@beneficiary-selector.not-found.text">
            We can't find what you are looking for. Please try a different criteria.</div>
          <div class="not-found-img"></div>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template bbTransactionsNoAccountSelectedStateCustomizable
    let-hostRef>
    <div class="card">
      <div class="bb-text-align-center card">
        <div class="bb-state-container banesco-empty-state">
          <div class="mb-3 bb-beneficiary-selector-ui__not-found-title empty-state-title"
            i18n="@@transactions.state.noProductSelected.title">
            No Product selected
          </div>
          <div class="mb-3"
            i18n="@@transactions.state.noProductSelected.subtitle">
            Please select a product first.
          </div>
          <div class="not-found-img"></div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template bbTransactionsListListCustomizable
    let-hostRef>
    <bn-transactions-list [hostRef]="hostRef"
      (transactionsTypeChange)="setAccountType($event)"
      (showBalanceDataChange)="setShowBalanceData($event)">
    </bn-transactions-list>
  </ng-template>

</bb-transactions-list-widget>
